import { GiftCardsAppConstant } from '@src/ib-gift-cards-constants';
import * as angular from 'angular';
import {CommonsConstantsType} from 'ib-web-commons/constants';
import { CommonsSessionStorageService } from 'ib-web-commons/utils';

export class GiftCardsUtilService {
    public numberAttemps: number = 0;
    constructor (
        private $filter: ng.IFilterService,
        private $window: ng.IWindowService,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private CommonsGenericProxy: CommonsGenericProxy,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private $cookies: angular.cookies.ICookiesService, private CommonsModalService:CommonsModalService,
        private GiftCardsAppConstants: GiftCardsAppConstant, private tmhDynamicLocale: any,
        private CommonsUserUtilsService: CommonsUserUtilsService,
        private CommonsUtilService: CommonsUtilService,
        private DatalayerConstants: DatalayerConstantsType,
        private CommonsConstants: CommonsConstantsType,
        private NewMainHeaderFacade: any,
        private $timeout: ng.ITimeoutService,
        private localStorageService: angular.local.storage.ILocalStorageService
    ) {

    }
    initTitle () {
        this.$timeout(() => {
            const confirmationDigitalInfo: Types.confirmationDigitalInfo = this.localStorageService.get('confirmationDigitalInfo');
            if(confirmationDigitalInfo && confirmationDigitalInfo.Quadrigam !== 'REPURC' && confirmationDigitalInfo.Quadrigam !== 'REBKCF' ) {
                this.CommonsUtilService.setTitlePage('GIFT_CARD_CONFIGURATION_REGOTR_TITLE');
            }
        }, 3000);
    }
    extractTimeFromDate = (date: string): string => {
        return date.split(' ')[1];
    };
    ckeckUserLogged (isUserLogged) : string {
        let userState = '';
        const logged: CommonsDatalayerServiceTypes.LoggedDatalayer | null = this.CommonsSessionStorageService.get('EstadoUsuario');
        const userLogged: any = this.CommonsSessionStorageService.get('userLogged');

        if (isUserLogged) {
            if (!this.CommonsUserUtilsService.getUserRole()) {
                this.CommonsUtilService.getUserTypeByToken();
            }
            userState =
            this.CommonsUserUtilsService.isIbPlus()
                ? (this.CommonsSessionStorageService.get('IB_PERMANENT_LOGIN') ? this.DatalayerConstants.DATALAYER_USER_STATES.LOGGED_FF_SOFT : this.DatalayerConstants.DATALAYER_USER_STATES.LOGGED_FF_HARD)
                : this.DatalayerConstants.DATALAYER_USER_STATES.LOGGED_IB;
            if (logged && logged.loggedBy) {
                userState = (logged.loggedBy === 'email') ? this.DatalayerConstants.DATALAYER_USER_STATES.LOGGED_MAIL : userState;
            } else {
                userState = (userLogged === this.CommonsConstants.LOGIN_ONB) ? this.DatalayerConstants.DATALAYER_USER_STATES.LOGGED_ONB : userState;
            }
        } else {
            userState = this.DatalayerConstants.DATALAYER_USER_STATES.ANONYMOUS;
        }

        return userState;
    }

    ////////////////
    /**
     * Returns the type of the device depending on the channel and the width of the screen.
     * @returns {Object.<Promise>} - returns a string. desktop|tablet|mobile
     */
    getDeviceType = (): string => {
        let deviceType: string = '';
        const channel: string = this.CommonsSessionStorageService.get('channel');
        if (channel === 'mobi') {
            deviceType = 'mobile';
        } else {
            const width = this.$window.innerWidth;
            if (width) {
                if (width > 1024) {
                    deviceType = 'desktop';
                } else if (width > 480 && width < 1025) {
                    deviceType = 'tablet';
                } else if (width < 481) {
                    deviceType = 'mobile';
                }
            }
        }
        return deviceType;
    };

    /**
     * Return date in string
     * @param {Object} date Date
     */
    getTransformedDate = (date: Date): string => {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    };
    activateSpecialCampaign (specialCampaign) { 
        this.CommonsSessionStorageService.set('specialCampaign', specialCampaign);
    }
    deactivateSpecialCampaign () {
        this.CommonsSessionStorageService.remove('specialCampaign');
    }
    /**
     * Remove all localstorage variables of the app and active special Campaign
     */
    initStorage = (): void => {
        this.CommonsSessionStorageService.clearAll(/(?!(ib-gift-cards-app.).*)^(ib-[\w\-]+-app\.[\w\-]+)/i, { withPrefix: false });
        this.CommonsSessionStorageService.remove('loggedToken');
        this.CommonsSessionStorageService.remove('refreshToken');
        this.CommonsSessionStorageService.remove('userLogged');
        this.CommonsSessionStorageService.remove('customerData');
        this.CommonsSessionStorageService.remove('customerCreditCardsData');
        this.CommonsSessionStorageService.remove(GiftCardsAppConstant.SESSION_STORAGE.PAYMENT_CONTEXT_RESPONSE);
        this.CommonsSessionStorageService.remove(GiftCardsAppConstant.SESSION_STORAGE.SUMMARY);
        const specialCampaign:Types.SpecialCampaign = 'HALLOWEEN';
        this.activateSpecialCampaign(specialCampaign);
        //this.deactivateSpecialCampaign();
    };

    getContributionData = (code, id) => {
        let response = {};
        const endPoint = this.GiftCardsAppConstants.DEFAULT_ENDPOINTS.AVAILABILITYPERMISSION.replaceAll('{code}', code).replaceAll('{id}', id);

        return new Promise ((resolve, reject) => {
            this.CommonsGenericProxy.getGeneric(`${endPoint}`).then((res) => {
                resolve(res.data);

            }, 
            (error => {
                reject(error);
            }));
        });
    };

    simplyDateFormater = (dateString) => {
        return dateString.substring(0, 10);
    };

    isContributionFlow= () => {
        let urlSplit = this.$window.location.href.split('/');
        let quadrigam = urlSplit[urlSplit.length - 1];

        return quadrigam == this.GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION ? true : false;
    };

    convertDateToUTC =(date:any):Date => {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    };

    tokenExpired = (tokenExpiration:string):boolean => {
        let ok = true;
        let tokenSplit = [];
        if (tokenExpiration) {
            tokenSplit = tokenExpiration.split('/');
            tokenExpiration = tokenSplit[1] + '/' + tokenSplit[0] + '/' + tokenSplit[2];
            const tokenDate = Date.parse(tokenExpiration);
            ok = tokenDate <= this.convertDateToUTC(new Date()).getTime();
        }
        return ok;
    };

    getLoggedCookiesInfo = (isContributionFlow?:boolean) => {
        const cookieAccessToken = this.$cookies.get('IBERIACOM_SSO_ACCESS');
        const cookieAccessTokenExpire = this.$cookies.get('IBERIACOM_SSO_ACCESS_TO');
        const cookieSSOINFO = this.$cookies.get('IBERIACOM_SSO_INFO');
        const cookieRefreshToken = this.$cookies.get('IBERIACOM_SSO_REFRESH');
        const cookieRefreshTokenExpire = this.$cookies.get('IBERIACOM_SSO_REFRESH_TO');
        const hasCookies = angular.isDefined(cookieRefreshToken) && !this.tokenExpired(cookieRefreshTokenExpire);
        let userLogged = false;
        if (hasCookies) {
            userLogged = true;
            this.CommonsSessionStorageService.set('userLogged', true);
            this.CommonsSessionStorageService.set('loggedToken', cookieAccessToken);
            this.CommonsSessionStorageService.set('refreshToken', cookieRefreshToken);
            this.getCustomerData();

        }
        hasCookies ? this.$timeout(() => {this.initHeader(isContributionFlow);}, 1000) : this.$timeout(() => {this.initHeader();}, 1000);
        return {
            userLogged: userLogged,
            cookieAccessToken: cookieAccessToken,
            cookieAccessTokenExpire: cookieAccessTokenExpire,
            cookieRefreshToken: cookieRefreshToken,
            cookieRefreshTokenExpire: cookieRefreshTokenExpire,
            cookieSSOINFO: cookieSSOINFO
        };
    };
    setQuadrigamInfo = ():string => {
        let cardDestiny:string;
        const localInfo:string = this.CommonsSessionStorageService.get('giftCardDestiny');
        cardDestiny = this.GiftCardsAppConstants.QUADRIGAMS.REGMIO;
        if(localInfo === 'REGOTR') {
            cardDestiny = this.GiftCardsAppConstants.QUADRIGAMS.REGOTR;
        }
        return cardDestiny;
    };
    /**
         * check if the current user is logged or not
         * @return true if the user is logged in the app
         */
    isUserLogged = (): boolean => {
        if (!this.CommonsSessionStorageService.get('userLogged')) {
            this.$cookies.remove('userLogged');
        } else {
            this.$cookies.put('userLogged', 'true');
        }
        return this.CommonsSessionStorageService.get('userLogged');
    };
    updateMarketLang = (marketLang) => {
        const lang = marketLang.language;
        const market = marketLang.market;
        const content = market + '|' + market + '|' + lang + '| | |' + market + '|';
        const expiration = new Date();
        expiration.setTime(expiration.getTime() + this.GiftCardsAppConstants.COOKIES.DEFAULT_EXPIRY_TIME);
        this.$cookies.put(this.GiftCardsAppConstants.COOKIES.PERSONALIZATION, content, { expires: expiration, path: this.GiftCardsAppConstants.COOKIES.DEFAULT_PATH });
        this.GiftCardsAppConstants.market = market;
        this.GiftCardsAppConstants.lang = lang;
        this.tmhDynamicLocale.set(lang);
    };

    initThemeQuadrigamLocal = (): void => {
        const quadrigam = this.GiftCardsAppConstants.QUADRIGAMS.REGOTR;
        this.CommonsSessionStorageService.set('theme', 'GIFT');
        this.CommonsSessionStorageService.set('cardDestiny', quadrigam);
    };

    getCustomerData = (): angular.IPromise<any | Types.ErrorResponse> => {

        const endpoint = this.GiftCardsAppConstants.DEFAULT_ENDPOINTS.customerDataURI;

        return new Promise ((resolve, reject) => {
            const getCustomerDataSuccess = (response: Types.ProxyResponse) => {
                this.CommonsModalService.finishWaiting();
                this.CommonsSessionStorageService.set('customerData', response.data);
                resolve(response);
            };
            const getCustomerDataError = (error: CommonsErrorsModel.ErrorDataGeneral) => {
                this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
            };

            this.CommonsGenericProxy.getGeneric(`${endpoint}`).then(getCustomerDataSuccess, getCustomerDataError);
        });
    };
    initHeader = (isContributionFlow?:boolean) => {
        const steps = isContributionFlow ? this.GiftCardsAppConstants.STEPS.CONTRIBUTION_STEPS : this.GiftCardsAppConstants.STEPS.STEPS;
        this.NewMainHeaderFacade.initHeader(
            {
                originDestination: null,
                redemption: '',
                flightType: null,
                currency: '',
                showBasket: false
            },
            { hasSteps: true, steps: steps, position: this.GiftCardsAppConstants.STEPS.HOME},
            {
                onLogin: (): void => { },
                onError: (): void => { },
                afterLogin: () => { },
                userLogged: this.CommonsSessionStorageService.get('userLogged'),
                isLogged: this.CommonsSessionStorageService.get('userLogged'),
                loggedData: this.CommonsSessionStorageService.get('customerData') || this.CommonsSessionStorageService.get('membershipData') || undefined,
                show: true
            }
        );
    };

    /**
     * Returns the market from url
     * @returns {string} - returns an string made from params
     */
    getParameterByName = (name: string, url?: string): string => {
        if (!url) url = this.$window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'gi' );
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return null;
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    /**
     * Redirection to Home
     * @param event
     * @param {Boolean} goToHome  Indicate if the redirection is for Home
     * @param {Boolean} closeSession indicate if neccesary delete the session
     * @returns {void}
     */
    backToMain = (goToHome: boolean, closeSession?: boolean) => {
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true, null);
        if (goToHome) {
            this.CommonsSessionStorageService.clearAll();
            this.$window.location.href = this.$window.location.origin;
        }
    };

    /**
     * Return the background image in the project.
     * @returns {String} - the background image url that matches with its destination city code in the data on localStorage
     */
    getBackGroundURL= () => {
        const innerWidth = this.$window.innerWidth;
        let widthScreen: number;
        if (innerWidth > 0 && innerWidth <= 480) {
            widthScreen = 320;
        } else if (innerWidth <= 1024) {
            widthScreen = 768;
        } else {
            widthScreen = 2000;
        }
        return `${this.GiftCardsAppConstants.backgroundImagesBaseRoute}${this.GiftCardsAppConstants.defaultBackgroundImageWidth}${widthScreen}.jpg`;
    };
}
GiftCardsUtilService.$inject = [
    '$filter', '$window', 'CommonsNewHttpUtilsErrorService',
    'CommonsGenericProxy',
    'CommonsSessionStorageService', '$cookies',
    'CommonsModalService', 'GiftCardsAppConstants', 'tmhDynamicLocale', 'CommonsUserUtilsService',
    'CommonsUtilService', 'DatalayerConstants', 'CommonsConstants', 'NewMainHeaderFacade', '$timeout', 'localStorageService'
];
try {
    const mod = angular.module('ib-gift-cards-service-module');
    mod.service(
        'GiftCardsUtilService',
        GiftCardsUtilService
    );
} catch (error) {
    const mod = angular.module('ib-gift-cards-service-module', []);
    mod.service(
        'GiftCardsUtilService',
        GiftCardsUtilService
    );
}
